export default __webpack_public_path__ + "static/media/accessory1.4a71a129.png";